import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  TextField,
} from '@mui/material';
import useSearchZone from 'api/locationZone/useSearchZone/useSearchZone';
import useDownloadWMSReports from 'api/WMSReports/useDownloadWMSReports';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';

const WMSReports = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [downloadWMSReports, downloadLoading] = useDownloadWMSReports();
  const [searchZones, searchedZonesLoading, searchedZones] = useSearchZone();
  const [selectedZone, setSelectedZone] = useState(null);
  const [zoneInputValue, setZoneInputValue] = useState();

  useEffect(() => {
    searchZones();
  }, []);

  const Deficit = () => {
    if (!!selectedZone) {
      downloadWMSReports({
        zoneGuid: selectedZone?.key,
        zoneTitle: selectedZone?.title,
      });
    } else {
      enqueueSnackbar('لطفا ابتدا انبار را انتخاب کنید', { variant: 'error' });
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#eee',
        borderRadius: 15,
        padding: 20,
        paddingRight: 30,
        paddingLeft: 40,
      }}
    >
      <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
        <div style={{ alignSelf: 'center', flex: 0.35 }}>
          <h3>گزارش موجودی انبار</h3>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ width: '360px' }}>
            <Autocomplete
              options={searchedZones || []}
              autoHighlight
              value={selectedZone || null}
              getOptionLabel={option => option.value}
              noOptionsText={
                <div className="w-full flex justify-center">موردی یافت نشد</div>
              }
              renderOption={(args, option) => (
                <div {...args} dir="rtl">
                  {option.value}
                </div>
              )}
              onChange={(event, newValue) => {
                setSelectedZone(prev => newValue);
              }}
              sx={{
                '.MuiInputBase-root': {
                  paddingRight: '9px !important',
                },
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{
                    '.MuiAutocomplete-endAdornment': {
                      right: 'unset !important',
                      left: '9px',
                    },
                    '.MuiAutocomplete-endAdornment button': {
                      mr: 0.5,
                    },
                  }}
                  label="انتخاب انبار"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'zone', // disable autocomplete and autofill
                  }}
                  className="gray-icon"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>

      <div style={{ flex: 1, textAlign: 'left', alignSelf: 'center' }}>
        <LoadingButton
          loading={downloadLoading}
          // loadingPosition="start"
          style={{ marginRight: 20 }}
          variant="contained"
          color="info"
          onClick={() => Deficit()}
        >
          دانلود گزارش موجودی
        </LoadingButton>
      </div>
    </div>
  );
};

export default WMSReports;
